import React, { FC, useState, useEffect } from 'react'
import { Button, Image } from 'react-bootstrap'
import { withRouter, RouteComponentProps, useHistory } from 'react-router-dom'
import LoginForm from './LoginForm'
import ConfirmForm from './ConfirmForm'
import mavLogo from '../../assets/img/gray_logo.svg'
import LoginLayout from './layout'
import './styles.scss'

interface Props extends RouteComponentProps {
  setIsAuthenticated: (isAuthenticated: boolean) => void
  setEmailUser: (emailUser: string) => void
  isAuthenticated: boolean
}

const Login: FC<Props> = ({ setEmailUser, setIsAuthenticated, isAuthenticated }) => {
  const [showLoginForm, setShowLoginForm] = useState(false)
  const [needsConfirming, setNeedsConfirming] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const history = useHistory()

  useEffect(() => {
    if (isAuthenticated) {
      history.push('/')
    }
  }, [])

  return (
    <LoginLayout>
      <div className="login">
        {needsConfirming ? (
          <ConfirmForm
            email={email}
            password={password}
            setIsAuthenticated={setIsAuthenticated}
            setEmail={setEmail}
            setPassword={setPassword}
          />
        ) : (
          <>
            {showLoginForm ? (
              <LoginForm
                setShowLoginForm={setShowLoginForm}
                setIsAuthenticated={setIsAuthenticated}
                setNeedsConfirming={setNeedsConfirming}
                setEmail={setEmail}
                setEmailUser={setEmailUser}
                setPassword={setPassword}
              />
            ) : (
              <div className="landing">
                <Image src={mavLogo} alt="Placeholder" className="logo-img" />
                <div className="actions">
                  <h1 className="title">Use your inbox for something good - selling!</h1>
                  <Button variant="primary" block onClick={(): void => setShowLoginForm(true)}>
                    Login to My Hangar
                  </Button>
                  <Button variant="primary" block onClick={(): void => history.push('/register')}>
                    Sign up for success
                  </Button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </LoginLayout>
  )
}

export default withRouter(Login)
